// Mantún (13-10-2026, copia del arreglo de FunFungi): la barra fija de compra (sticky-atc de Shrine) muestra el precio de la opción elegida en Kaching,
// más lo agregado con su casilla (si la oferta trae agregados), con el precio tachado si hay descuento.
// Antes mostraba siempre el precio de 1 unidad aunque el botón agregara la opción elegida.
// Sin Kaching en la página, la barra queda como siempre. Se carga desde snippets/mt-tienda.liquid en las fichas.
(function () {
  if (window.mtBarraPrecio) return;
  window.mtBarraPrecio = true;

  function numero(el) {
    return el ? parseInt(el.textContent.replace(/\D/g, ''), 10) || 0 : 0;
  }
  function plata(n) {
    return '$' + n.toLocaleString('es-CL');
  }
  // Escribir solo si cambia: el observador mira la misma sección y no debe entrar en bucle
  function poner(el, texto) {
    if (el.textContent !== texto) el.textContent = texto;
  }

  function seccion() {
    var barra = document.querySelector('sticky-atc[data-section]');
    return (barra && document.getElementById('shopify-section-' + barra.dataset.section)) || document;
  }

  // 17-10-2026 (escalera nativa, como FunFungi): sin Kaching Bundles, el precio y el tachado salen de la opción
  // marcada en la escalera de Shrine (quantity-breaks), que ya vienen calculados en su etiqueta.
  function escalera(raiz) {
    var r = raiz.querySelector('quantity-breaks input[name="quantity"]:checked') || document.querySelector('quantity-breaks input[name="quantity"]:checked');
    var lab = r && r.id && document.querySelector('label[for="' + r.id + '"]');
    if (!lab) return null;
    var precio = numero(lab.querySelector('.quantity-break__price'));
    if (!precio) return null;
    var tachado = lab.querySelector('.quantity-break__compare-price');
    var antes = tachado && !tachado.classList.contains('hidden') ? numero(tachado) : 0;
    return { precio: precio, antes: Math.max(antes, precio) };
  }

  function calcular(raiz) {
    var opcion = raiz.querySelector('.kaching-bundles__bar--selected') || document.querySelector('.kaching-bundles__bar--selected');
    if (!opcion) return escalera(raiz);
    var precio = numero(opcion.querySelector('.kaching-bundles__bar-price'));
    if (!precio) return null;
    var antes = numero(opcion.querySelector('.kaching-bundles__bar-full-price')) || precio;
    opcion.querySelectorAll('.kaching-bundles__upsell').forEach(function (u) {
      if (!u.querySelector('.kaching-bundles__upsell__checkbox--selected')) return;
      var p = numero(u.querySelector('.kaching-bundles__upsell__price'));
      precio += p;
      antes += numero(u.querySelector('.kaching-bundles__upsell__full-price')) || p;
    });
    return { precio: precio, antes: antes };
  }

  function pintar() {
    var r = calcular(seccion());
    if (!r) return;
    var enOferta = r.antes > r.precio;
    document.querySelectorAll('.sticky-atc .price').forEach(function (cont) {
      if (cont.classList.contains('price--on-sale') !== enOferta) cont.classList.toggle('price--on-sale', enOferta);
      cont.querySelectorAll('.price__regular .price-item--regular, .price__sale .price-item--sale').forEach(function (e) {
        poner(e, plata(r.precio));
      });
      cont.querySelectorAll('.price__sale .price__compare-price s').forEach(function (e) {
        poner(e, enOferta ? plata(r.antes) : '');
      });
      cont.querySelectorAll('.badge__percentage-saved').forEach(function (e) {
        poner(e, enOferta ? String(Math.round(((r.antes - r.precio) * 100) / r.antes)) : '');
      });
    });
  }

  var pendiente = false;
  function programar() {
    if (pendiente) return;
    pendiente = true;
    requestAnimationFrame(function () {
      pendiente = false;
      pintar();
    });
  }

  function iniciar() {
    if (!document.querySelector('.sticky-atc .price')) return;
    var raiz = seccion();
    // Kaching dibuja sus opciones unos segundos después y las vuelve a dibujar al elegir: mirar la sección entera
    new MutationObserver(programar).observe(raiz === document ? document.body : raiz, {
      subtree: true,
      childList: true,
      characterData: true,
      attributes: true,
      attributeFilter: ['class'],
    });
    // Marcar un radio no cambia el DOM (es una propiedad): escuchar el cambio de la escalera.
    document.addEventListener('change', function (e) {
      if (e.target && e.target.name === 'quantity') programar();
    });
    programar();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar);
  else iniciar();
})();

// 13-10-2026 (pedido de Mau, igual que FunFungi): el botón flotante de WhatsApp (#mantun-whatsapp-float) tapaba el precio
// de las opciones. 17-10 (versión completa de FunFungi del 16-10): se esconde en celular y computador mientras se ve
// cualquier parte de la zona de compra (escalera de Shrine, bloque de regalos, formulario, cuotas) o con la página arriba
// del todo; vuelve en la descripción. La pestaña de Klaviyo (kl-teaser-*), en celular, recién aparece debajo de toda la
// zona de compra y queda sobre la barra fija. La barra fija entra cuando al botón principal le quedan 100 px para llegar
// al encabezado (Shrine la mostraba recién cuando el botón ya había salido: quedaba un tramo sin botón a la vista).
// La zona se vuelve a buscar en cada vuelta: el editor de temas redibuja la sección y los nodos viejos se pierden.
(function () {
  if (window.mtWaCompra || !document.querySelector) return;
  window.mtWaCompra = true;
  var ZONA = 'product-form.main-product-form, quantity-breaks, .ffrg, [data-mtc], kaching-bundle, .kaching-bundles';

  function iniciar() {
    if (!document.querySelector('product-form.main-product-form')) return;
    var estilo = document.createElement('style');
    estilo.textContent = 'body.mt-compra-en-vista #mantun-whatsapp-float { display: none !important; }' +
      '@media (max-width: 749px) {' +
      ' body.mt-teaser-espera [class*="kl-teaser-"] { visibility: hidden !important; opacity: 0 !important; pointer-events: none !important; }' +
      ' [class*="kl-teaser-"] { bottom: var(--mt-barra-fija, 0px) !important; transition: bottom .25s ease, opacity .2s ease; }' +
      '}' +
      'body.mt-barra-ya sticky-atc[data-display-mode="after_scroll"] { transform: none !important; }';
    document.head.appendChild(estilo);
    var raizHtml = document.documentElement;
    var altoPuesto = -1;

    // Solo dentro de la sección de la ficha: el carrito lateral (cerrado) también trae cuotas y contaría siempre.
    function zonas() {
      var form = document.querySelector('product-form.main-product-form');
      var seccion = form && form.closest('.shopify-section, section');
      var lista = Array.prototype.slice.call((seccion || document).querySelectorAll(ZONA));
      if (form && form.parentElement) lista.push(form.parentElement);
      return lista;
    }

    function adelantarBarra() {
      var boton = document.querySelector('product-form.main-product-form .product-form__submit');
      if (!boton) return;
      var cab = document.querySelector('sticky-header, .header-wrapper, header');
      var limite = Math.max(0, cab ? cab.getBoundingClientRect().bottom : 0) + 100;
      var r = boton.getBoundingClientRect();
      document.body.classList.toggle('mt-barra-ya', r.height > 0 && r.bottom < limite);
    }

    function revisar() {
      adelantarBarra();
      var alto = window.innerHeight;
      var enVista = false;
      var fondo = -Infinity;
      zonas().forEach(function (z) {
        var r = z.getBoundingClientRect();
        if (!r.height) return;
        if (r.bottom > 0 && r.top < alto) enVista = true;
        if (r.bottom > fondo) fondo = r.bottom;
      });
      document.body.classList.toggle('mt-compra-en-vista', enVista || window.scrollY < 120);
      document.body.classList.toggle('mt-teaser-espera', fondo > 0);
      var barra = document.querySelector('sticky-atc');
      if (barra) {
        var visto = Math.max(0, Math.round(alto - barra.getBoundingClientRect().top));
        if (visto > barra.offsetHeight + 2) visto = 0;
        if (visto !== altoPuesto) { altoPuesto = visto; raizHtml.style.setProperty('--mt-barra-fija', visto + 'px'); }
      }
    }

    var pendiente = false;
    function programar() {
      if (pendiente) return;
      pendiente = true;
      requestAnimationFrame(function () { pendiente = false; revisar(); });
    }
    window.addEventListener('scroll', programar, { passive: true });
    window.addEventListener('resize', programar);
    document.addEventListener('transitionend', function (e) { if (e.target && e.target.matches && e.target.matches('sticky-atc')) programar(); });
    document.addEventListener('shopify:section:load', programar);
    revisar();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar);
  else iniciar();
})();

// 17-10-2026 (como FunFungi): Shrine pone aria-label="Quantity" (en inglés) a cada opción de la escalera y un lector de
// pantalla leía «Quantity» en vez de la opción. Se cambia a «Cantidad: 2 Kits» sin tocar el archivo de Shrine.
(function () {
  if (window.mtCantidadAria) return;
  window.mtCantidadAria = true;
  function poner() {
    document.querySelectorAll('quantity-breaks input[type="radio"][name="quantity"]').forEach(function (r) {
      var lab = r.id && document.querySelector('label[for="' + r.id + '"]');
      var txt = lab && lab.querySelector('.quantity-break__label-text');
      var etiqueta = 'Cantidad: ' + (txt ? txt.textContent.replace(/\s+/g, ' ').trim() : r.value);
      if (r.getAttribute('aria-label') !== etiqueta) r.setAttribute('aria-label', etiqueta);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', poner);
  else poner();
  document.addEventListener('change', function () { setTimeout(poner, 300); });
  document.addEventListener('shopify:section:load', poner);
})();

// 17-10-2026: en la escalera de Shrine, cada unidad trae un selector por opción del producto. Los kits y los packs tienen
// «Dimensiones» con un solo valor (33x34x43, 20x20x16): ese selector no sirve y ocupaba media fila. Se esconden los que
// tienen una sola opción; el valor igual viaja en el formulario.
(function () {
  if (window.mtSelectoresUnicos) return;
  window.mtSelectoresUnicos = true;
  function esconder() {
    document.querySelectorAll('quantity-breaks select').forEach(function (s) {
      var unico = s.options.length <= 1;
      var caja = s.closest('.select') || s.parentElement;
      // Shrine le pone display al contenedor: el atributo hidden no basta
      if (caja) caja.style.display = unico ? 'none' : '';
    });
    // Productos sin variedades (Pack de Sustratos para Bulk) en una plantilla con selectores: sin ningún selector útil,
    // se esconden también la fila «Pack #1» y el título «Elige la variedad de esporas:» (quedaban vacíos).
    document.querySelectorAll('quantity-breaks .quantity-break__selector-item').forEach(function (it) {
      var util = [].some.call(it.querySelectorAll('select'), function (x) { return x.options.length > 1; });
      it.style.display = util ? '' : 'none';
    });
    document.querySelectorAll('quantity-breaks .quantity-break__variants').forEach(function (v) {
      var util = [].some.call(v.querySelectorAll('select'), function (x) { return x.options.length > 1; });
      v.style.display = util ? '' : 'none';
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', esconder);
  else esconder();
  document.addEventListener('change', function () { setTimeout(esconder, 300); });
  document.addEventListener('shopify:section:load', esconder);
})();

// 17-10-2026 (como FunFungi, «maqueta D»): «Ahorras $X» a la derecha, bajo el precio tachado de cada opción de la
// escalera, y la escalera más limpia (cantidad en negrita, precio por unidad más suave, opciones más compactas).
// El ahorro se calcula con los mismos dos números que muestra la opción (tachado − precio): siempre calza con lo que
// se ve, también cuando mt-escalera.js reescribe los precios según el carrito. Solo agrega un <span>; no toca los de Shrine.
(function () {
  if (window.mtAhorroEscalera) return;
  window.mtAhorroEscalera = true;
  var css = document.createElement('style');
  css.textContent =
    'quantity-breaks .quantity-break__label-text{font-weight:700}' +
    'quantity-breaks .quantity-break__caption,quantity-breaks .quantity-break__caption strong{font-weight:500}' +
    'quantity-breaks .quantity-break__caption{opacity:.8}' +
    'quantity-breaks .quantity-break__wrapper{padding-top:11px;padding-bottom:11px}' +
    'quantity-breaks .quantity-break__left{gap:4px}' +
    'quantity-breaks .quantity-break__benefit{white-space:nowrap;flex:0 0 auto}' +
    'quantity-breaks .quantity-break .ffrg-qb{margin-top:2px;line-height:1.3}' +
    'quantity-breaks .mt-qb-ahorro{display:block;margin-top:2px;font-size:12px;font-weight:700;line-height:1.2;white-space:nowrap;color:#c55281}';
  document.head.appendChild(css);
  function numero(el) { return el ? parseInt(el.textContent.replace(/\D/g, ''), 10) || 0 : 0; }
  function poner() {
    document.querySelectorAll('quantity-breaks label.quantity-break').forEach(function (lab) {
      var der = lab.querySelector('.quantity-break__right');
      if (!der) return;
      var precio = numero(der.querySelector('.quantity-break__price'));
      var tachado = der.querySelector('.quantity-break__compare-price');
      var antes = tachado && !tachado.classList.contains('hidden') ? numero(tachado) : 0;
      var ahorro = antes > precio && precio ? antes - precio : 0;
      var el = der.querySelector('.mt-qb-ahorro');
      if (!ahorro) { if (el) el.remove(); return; }
      var texto = 'Ahorras $' + ahorro.toLocaleString('es-CL');
      if (!el) { el = document.createElement('span'); el.className = 'mt-qb-ahorro'; der.appendChild(el); }
      if (el.textContent !== texto) el.textContent = texto;
    });
  }
  var pendiente = false;
  function programar() {
    if (pendiente) return;
    pendiente = true;
    requestAnimationFrame(function () { pendiente = false; poner(); });
  }
  function iniciar() {
    var q = document.querySelector('quantity-breaks');
    if (!q) return;
    poner();
    // Shrine (y mt-escalera.js) reescriben los precios: mirar solo la escalera, no toda la página.
    new MutationObserver(programar).observe(q, { subtree: true, childList: true, characterData: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar);
  else iniciar();
  document.addEventListener('shopify:section:load', function () { setTimeout(iniciar, 0); });
})();
